import React, { useState, useEffect } from 'react';

function EmployeeForm({ employee, workshops, zones, roles, currentShift, onSave, onClose }) {
  const [form, setForm] = useState({
    full_name: '',
    tab_number: '',
    phone: '',
    birth_date: '',
    gender: 'м',
    is_vakhta: false,
    day_off: 'воскресенье',
    workshop_id: '',
    zone_id: '',
    section_id: '',
    slot_id: '',
    comment: '',
    shift: currentShift || 'day'
  });

  const [sections, setSections] = useState([]);
  const [slots, setSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);

  useEffect(() => {
    if (employee) {
      setForm({
        full_name: employee.full_name || '',
        tab_number: employee.tab_number || '',
        phone: employee.phone || '',
        birth_date: employee.birth_date ? employee.birth_date.split('T')[0] : '',
        gender: employee.gender || 'м',
        is_vakhta: employee.is_vakhta || false,
        day_off: employee.day_off || 'воскресенье',
        workshop_id: employee.workshop_id || '',
        zone_id: employee.zone_id || '',
        section_id: '',
        slot_id: employee.slot_id || '',
        comment: employee.comment || '',
        shift: employee.shift || currentShift || 'day'
      });
    }
  }, [employee, currentShift]);

  useEffect(() => {
    if (employee && employee.slot_id) {
      fetch(`/api/slot-info?slot_id=${employee.slot_id}`)
        .then((r) => r.json())
        .then((data) => {
          if (data && data.section_id) {
            setForm((prev) => ({
              ...prev,
              section_id: data.section_id
            }));
          }
        })
        .catch(() => {});
    }
  }, [employee]);

  useEffect(() => {
    if (!form.zone_id) {
      setSections([]);
      return;
    }
    fetch(`/api/sections?zone_id=${form.zone_id}`)
      .then((r) => r.json())
      .then((data) => setSections(data))
      .catch(() => setSections([]));
  }, [form.zone_id]);

  useEffect(() => {
    if (!form.section_id) {
      setSlots([]);
      return;
    }
    setLoadingSlots(true);
    fetch(
      `/api/slots?section_id=${form.section_id}&current_employee=${
        employee ? employee.id : 0
      }&shift=${form.shift}`
    )
      .then((r) => r.json())
      .then((data) => {
        setSlots(data);
        setLoadingSlots(false);
      })
      .catch(() => {
        setSlots([]);
        setLoadingSlots(false);
      });
  }, [form.section_id, form.shift, employee]);

  const filteredZones = zones.filter(
    (z) => z.workshop_id === parseInt(form.workshop_id)
  );

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => {
      const newForm = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
      if (name === 'workshop_id') {
        newForm.zone_id = '';
        newForm.section_id = '';
        newForm.slot_id = '';
      }
      if (name === 'zone_id') {
        newForm.section_id = '';
        newForm.slot_id = '';
      }
      if (name === 'section_id') {
        newForm.slot_id = '';
      }
      if (name === 'shift') {
        newForm.slot_id = '';
      }
      return newForm;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.full_name.trim()) {
      alert('Введите ФИО');
      return;
    }

    const data = {
      full_name: form.full_name,
      tab_number: form.tab_number || null,
      phone: form.phone || null,
      birth_date: form.birth_date || null,
      gender: form.gender,
      is_vakhta: form.is_vakhta,
      day_off: form.day_off,
      workshop_id: form.workshop_id ? parseInt(form.workshop_id) : null,
      zone_id: form.zone_id ? parseInt(form.zone_id) : null,
      slot_id: form.slot_id ? parseInt(form.slot_id) : null,
      role_id: null,
      comment: form.comment || null,
      shift: form.shift
    };

    onSave(data);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{employee ? '✏️ Редактировать' : '➕ Добавить сотрудника'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {/* СМЕНА */}
          <div className="form-section">
            <div className="form-section-title">🕐 Смена</div>
            <div className="shift-radio-group">
              <label className={`shift-radio ${form.shift === 'day' ? 'active' : ''}`}>
                <input
                  type="radio"
                  name="shift"
                  value="day"
                  checked={form.shift === 'day'}
                  onChange={handleChange}
                />
                ☀️ День
              </label>
              <label className={`shift-radio ${form.shift === 'night' ? 'active' : ''}`}>
                <input
                  type="radio"
                  name="shift"
                  value="night"
                  checked={form.shift === 'night'}
                  onChange={handleChange}
                />
                🌙 Ночь
              </label>
            </div>
          </div>

          {/* ФИО */}
          <div className="form-group">
            <label>ФИО *</label>
            <input
              type="text"
              name="full_name"
              value={form.full_name}
              onChange={handleChange}
              placeholder="Иванов Иван Иванович"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Табельный номер</label>
              <input
                type="text"
                name="tab_number"
                value={form.tab_number}
                onChange={handleChange}
                placeholder="123"
              />
            </div>
            <div className="form-group">
              <label>Телефон</label>
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+7 900 000-00-00"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Дата рождения</label>
              <input
                type="date"
                name="birth_date"
                value={form.birth_date}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Пол</label>
              <select name="gender" value={form.gender} onChange={handleChange}>
                <option value="м">Мужской</option>
                <option value="ж">Женский</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="is_vakhta"
                  checked={form.is_vakhta}
                  onChange={handleChange}
                  style={{ marginRight: '6px' }}
                />
                Вахта
              </label>
            </div>
            <div className="form-group">
  <label>Выходной день</label>
  <select name="day_off" value={form.day_off || ''} onChange={handleChange}>
    <option value="">— Не выбран —</option>
    <option>понедельник</option>
    <option>вторник</option>
    <option>среда</option>
    <option>четверг</option>
    <option>пятница</option>
    <option>суббота</option>
    <option>воскресенье</option>
  </select>
</div>
          </div>

          {/* РАССТАНОВКА */}
          <details className="form-section" open>
            <summary className="form-section-title">
              📋 Расстановка
            </summary>

            <div className="form-row" style={{ marginTop: '10px' }}>
              <div className="form-group">
                <label>Цех</label>
                <select
                  name="workshop_id"
                  value={form.workshop_id}
                  onChange={handleChange}
                >
                  <option value="">— Не выбран —</option>
                  {workshops.map((w) => (
                    <option key={w.id} value={w.id}>{w.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Зона</label>
                <select
                  name="zone_id"
                  value={form.zone_id}
                  onChange={handleChange}
                  disabled={!form.workshop_id}
                >
                  <option value="">— Не выбрана —</option>
                  {filteredZones.map((z) => (
                    <option key={z.id} value={z.id}>{z.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Участок</label>
                <select
                  name="section_id"
                  value={form.section_id}
                  onChange={handleChange}
                  disabled={!form.zone_id}
                >
                  <option value="">— Не выбран —</option>
                  {sections.map((s) => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Должность</label>
                <select
                  name="slot_id"
                  value={form.slot_id}
                  onChange={handleChange}
                  disabled={!form.section_id || loadingSlots}
                >
                  <option value="">
                    {loadingSlots ? '⏳ Загрузка...' : '— Не выбрана —'}
                  </option>
                  {slots.map((s) => (
                    <option
                      key={s.id}
                      value={s.id}
                      disabled={s.occupied && String(s.id) !== String(form.slot_id)}
                    >
                      {s.display_label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </details>

          <div className="form-group">
            <label>Комментарий</label>
            <textarea
              name="comment"
              value={form.comment}
              onChange={handleChange}
              rows="2"
              placeholder="Заметки о сотруднике..."
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Отмена
            </button>
            <button type="submit" className="btn-save">
              {employee ? 'Сохранить' : 'Добавить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EmployeeForm;